/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { ColumnModel, DataModel, YesNoEnum, countNumberDecimals } from '@shared';
import { NormalizeDatabaseValuesService } from '../normalize-database-values.service';
import { ViewConfigurationService } from 'src/domain/view-configuration';
import { QueryParamsProvider } from '@domain/routing';
import { stringify } from 'querystring';

@Injectable()
export class InheritedValuesService {
	public constructor(
		private dbValuesNormalizer: NormalizeDatabaseValuesService,
		private queryParamsProvider: QueryParamsProvider,
		private viewConfigurationService: ViewConfigurationService
	) {}

	public getPrePopulated(
		column: Partial<ColumnModel>,
		previousRecord: DataModel | null,
		previousRecordColumn?: Partial<ColumnModel>
	): any {		
		if (!previousRecord || (column?.default_value !== undefined && column?.default_value !== '')) {
			return null;
		}

		const customInheritedValue = this.getCustomInheritedValue(column, previousRecord, previousRecordColumn);
		if (customInheritedValue) {
			return customInheritedValue;
		}

		const inheritedDepthToFromValue = this.getInheritedDepthToFrom(column, previousRecord);
		if (inheritedDepthToFromValue !== null) {
			return inheritedDepthToFromValue;
		}

		const inheritedValue = this.getInheritedValues(column, previousRecord);
		if (inheritedValue !== null) {
			return inheritedValue;
		}

		return null;
	}

	public getInheritedDepthToFrom(column: Partial<ColumnModel>, previousRecord: DataModel | null): any {
		// console.log(previousRecord.depth_to, previousRecord.depth_from, "depth");

		if (column.column_name === WorkspaceDatabaseKeys.columns.depthFrom) {
			if(previousRecord.depth_to) {
				return this.dbValuesNormalizer.prepareFormValue(column, previousRecord.depth_to);
			}
		}

		if (column.column_name === WorkspaceDatabaseKeys.columns.depthTo) {
			if(previousRecord.depth_to && previousRecord.depth_from) {
				const depthGap: number = Number(previousRecord.depth_to) - Number(previousRecord.depth_from);

				const depthToValue: number = Number(previousRecord.depth_to) + depthGap;

				return this.dbValuesNormalizer.prepareFormValue(
					column,
					Number(
						parseFloat(depthToValue.toString()).toFixed(
							this.getMaxNumberOfDecimals([
								previousRecord.depth_from.toString(),
								previousRecord.depth_to.toString()
							])
						)
					)
				);
			}

			
		}

		return null;
	}

	public getCustomInheritedValue(
		column: Partial<ColumnModel>,
		previousRecord: DataModel | null,
		previousRecordColumn?: Partial<ColumnModel>
	): string | boolean | number | null {
		const isColumnInheritValues: boolean =
			column.inherit_values &&
			column.inherit_values === YesNoEnum.Yes &&
			column.inherit_values_column &&
			column.inherit_values_column !== '';
		const isPreviousRecordOfSameType: boolean =
			column.data_type &&
			previousRecordColumn &&
			previousRecordColumn.data_type &&
			column.data_type === previousRecordColumn.data_type;

		if (previousRecord && isColumnInheritValues && isPreviousRecordOfSameType) {
			return this.dbValuesNormalizer.prepareFormValue(
				column,
				previousRecord[column.inherit_values_column.toLowerCase()]
			);
		}

		return null;
	}

	public insertLatestValue(hole_id: any, new_value: number) {
		localStorage.setItem(hole_id, new_value.toString())
	}

	public getInheritedValues(
		column: Partial<ColumnModel>,
		previousRecord: DataModel | null
	): string | boolean | number | null {
		if (column.inherit_values === YesNoEnum.Yes && previousRecord[column.column_name] !== undefined) {
			return this.dbValuesNormalizer.prepareFormValue(column, previousRecord[column.column_name]);
		}

		return null;
	}

	private getMaxNumberOfDecimals(values: string[]): number {
		const nolist: number[] = values.map((v: string) => countNumberDecimals(Number(v), '.'));
		return Math.max(...nolist);
	}
}
